import Vue from 'vue'

export default {
    /*
    * Updates page title and meta description
    */
    updateMedadata(title, description) {
        document.title = title;
        let metaDesc = document.querySelector('meta[name="description"]');

        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.insertBefore(metaDesc, document.querySelector('meta[name="author"]'));
        }

        metaDesc.setAttribute("content", description);
    },

    /*
    * Function to convert a Nitrous Uri model to a Vue route
    */
    convertUriToRoute(uri, prefetch = true) {
        let meta = {
            id: uri.id,
            title: uri.page_title,
            description: uri.meta_description,
            isHome: uri.is_home,
            model: uri.uriable.parent
        };

        meta.loadData = () => {
            return Http.get(`/api/${uri.slug}`);
        };

        let route = {
            name: uri.is_home ? 'home' : `page-${uri.id}`,
            path: '/' + (uri.slug == '/' ? '' : uri.slug),
            component: () => System.import('#app#/components/package/' + uri.uriable_type + 'Controller.vue' /* webpackChunkName: "[request]" */),
            meta: meta
        };

        return route;
    },

    /*
    * Function for scrolling to an anchor
    */
    scrollToAnchor(anchor) {
        const el = document.querySelector(anchor);
        if (el) {
            setTimeout(() => Vue.helpers.scrollTo(el), Vue.pageTransitionDuration);
        }
    },
}


// WEBPACK FOOTER //
// ../default-js/js/router/functions.js